import { instance } from "libs/api";

import { ApiRoutesContent } from "../../constants/enums";
import { FAQListItem } from "../../content.types";
import { CreateFaqItemRequestBody } from "./createFaqItem.types";

export const requestCreateFaqItem = async (
  body: CreateFaqItemRequestBody
): Promise<FAQListItem> => {
  return await instance.post(ApiRoutesContent.FAQItems, body);
};
